import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { importProvidersFrom } from '@angular/core';
import { AppModule } from './app/app.module';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import Clarity from "@microsoft/clarity";

// Merge the AppModule providers with the existing appConfig
const mergedConfig = {
  providers: [
    ...appConfig.providers,
    importProvidersFrom(AppModule)
  ]
};
const projectId = "tu5to9pq36"

Clarity.init(projectId);
bootstrapApplication(AppComponent, mergedConfig)
  .catch((err) => console.error(err));
